module.exports = __webpack_public_path__ + "static/media/defaultProfileImage.8bc5465e.png";